
import Vue from "vue"
import NavHelpCentreBase from "~/mixins/navHelpCentre"

export default Vue.extend({
  name: "NavHelpCentreEn",
  extends: NavHelpCentreBase
})
